import {
  Grid,
  Paper,
  TableContainer,
  TextField,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import CustomButton from "../../../Components/CustomButton";
import LeftSideNav from "../../../Components/LeftSideNav";
import Loader from "../../../Components/Loader";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import { addProductMetalPurityDetailsAPI } from "../../../Store/Action/productPurityAction";
import Colors from "../../../theme/Colors";

const AddProductPurity = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [loading, setLoading] = useState(false);


  const onSubmit = async (data) => {
    const requestData = {
     product_metal_purity_value: data?.metalPurityValue,
     product_metal_id: data?.id,
    }
    setLoading(true);
    try {
      await dispatch(
        addProductMetalPurityDetailsAPI(requestData, (isSuccess, response) => {
          setLoading(false);
          if (isSuccess?.status === true) {
            toast.success(response?.data?.message);
            navigate("/productPurity");
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      setLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Home" },
      { key: "2", href: "/userList", text: "Masters" },
      { key: "3", href: "/productPurity", text: "Product Purity" },
      { key: "3", href: "/AddProductPurity", text: "Add Product Purity" },
    ]);
  }, []);

  return (
    <div style={mainContainer}>
      <LeftSideNav />

      <div style={leftNavContainer}>
        <div style={topBar}>
          <TopNavBar />

          <div style={pageTitle}>
            <h2>Product Purity</h2>
          </div>

          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer component={Paper} style={tableContainer}>
          <p style={mainHeadingStyle}>Product Purity Information</p>

          <hr />

          <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>
                  Metal Purity Value
                </Typography>
                <Controller
                  name="metalPurityValue"
                  control={control}
                  defaultValue=""
                  rules={{ required: Strings.productValueRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter metal purity value"
                      variant="outlined"
                      fullWidth
                      error={!!errors.metalPurityValue}
                      helperText={
                        errors.metalPurityValue ? errors.metalPurityValue.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle, // Set background color
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Metal Id</Typography>
                <Controller
                  name="id"
                  control={control}
                  defaultValue=""
                  rules={{ required: Strings.metalIdRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      variant="outlined"
                      placeholder="Enter metal id"
                      fullWidth
                      error={!!errors.id}
                      helperText={errors.id ? errors.id.message : ""}
                      InputProps={{
                        style: inputTextStyle, // Set background color
                      }}
                    />
                  )}
                />
              </Grid>

              <CustomButton handleSubmit={handleSubmit} label={Strings.Save} />
            </Grid>
          </form>
        </TableContainer>
      </div>

      
      <Loader loading={loading} />
    </div>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: "#F0F5FF",
};

const topBar = {
  backgroundColor: "white",
  height: "7vh",
  width: "100%",
};

const pageTitle = {
  marginLeft: "30px",
  justifyContent: "flex-start",
  display: "flex",
};

const tableContainer = {
  width: "70vw",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "40px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "30px",
};

const formStyle = {
  padding: "20px",
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
};

const labelInfoStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginBottom: "5px",
};

const inputTextStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.darkGray,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  backgroundColor: Colors.lightBlue,
};

const btnStyle = {
  height: "40px",
  width: "12vh",
  borderRadius: "8px",
  border: "1px solid #4A505C",
  fontSize: 14,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  marginTop: "10px",
};

export default AddProductPurity;
